import PuttersRecommendationCardPDF from './PuttersRecommendationCardPDF';

export default PuttersRecommendationCardPDF;
